'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var scope = require('./scope.js');

var fnParams = [scope['default']._];

exports['default'] = fnParams;
